import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgSearchIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgSearchStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgSearchIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const SearchIcon: any = SvgSearchStyle;
export default SearchIcon;
